import React, { useRef, useState, useEffect } from "react";
import "primereact/resources/primereact.min.css";
import "primereact/resources/themes/lara-light-indigo/theme.css";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import instance from "../../api/api.js";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { Dialog } from "primereact/dialog";
import { FilterMatchMode } from "primereact/api";
import { InputText } from "primereact/inputtext";

import { TabView, TabPanel } from "primereact/tabview";
import { MdDeleteOutline } from "react-icons/md";


import AllCompomentShared from "../../shared/compoments/AllCompomentShared.jsx";
import { MdOutlineDelete } from "react-icons/md";
import { styleIcone } from "../../shared";
import { MenuPoint, ModalDelete } from "../../shared/compoments";
// import { IoPersonOutline } from "react-icons/io5"
import { GoHome } from "react-icons/go";

function ListeCategorie() {
  const [categories, setCategories] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [filters, setFilters] = useState({
    global: { value: null, matchMode: FilterMatchMode.CONTAINS },
    nom: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    email: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
    phone: { value: null, matchMode: FilterMatchMode.EQUALS },
  });
  const [globalFilterValue, setGlobalFilterValue] = useState("");
  const onGlobalFilterChange = (e) => {
    const value = e.target.value;
    let _filters = { ...filters };

    _filters["global"].value = value;

    setFilters(_filters);
    setGlobalFilterValue(value);
  };
  useEffect(() => {
    const getListCategorie = async () => {
      setIsLoading(true);
      try {
        const response = await instance.get("categories");
        console.log("CATEGORIE", response.data.data);
        setCategories(response.data.data);
        setIsLoading(false);
      } catch (error) {
        console.log(error);
        setIsLoading(false);
      }
    };
    getListCategorie();
  }, []);
  return (
    <AllCompomentShared
    libelleHeaderComp={"Catégories de biens"}
    titleStatisticHeaderComp={"Nombre de catégories"}
    nbreTotalStatistiqueComp={categories.length}
    SearchTableIsSearch={true}
    placeholderInputSearch={"Recherche"}
    globalFilterValue={globalFilterValue}
    onGlobalFilterChange={onGlobalFilterChange}
    iconeStatistiqueHeader={<GoHome fontSize={"2em"}/>} 
    isLoading={isLoading}
  >
    <CategorieDatatable items={categories} filters={filters} />
  </AllCompomentShared>
  );
}

function CategorieDatatable({ items,filters }) {
    // const MySwal = withReactContent(Swal);
  const dt = useRef(null);
  const [open,setOpen] = useState(false);
  const options = [
    {
      name: "Supprimer",
      icone: <MdOutlineDelete style={styleIcone} />,
      isIdData: true,
      addMethodClick: true,
        methode: (idData) => {
          isDeleteCategorie(idData);
        },
    },
  ];
  const isDeleteCategorie = (id) => {
    console.log(id);
    setOpen(true);
  };
  // const [visible, setVisible] = useState(false);
  // const [idCategorie, setIdCategorie] = useState("");
  // const [valueOfCategorie, setValueOfCategorie] = useState("");
  // const [visibleModifier, setVisibleModifier] = useState(false);
  // const [isLoadingChange, setIsLoadingChange] = useState(false);
  // const [dataModif, setDataModif] = useState({
  //   libelle: "",
  // });

  // const handleCatgeorie = (id) => {
  //   console.log("idCategorie", id);
  //   setIdCategorie(id);
  //   setVisible(true);
  // };
  // const modifCatgeorie = (id) => {
  //   console.log("idCategorie", id);
  //   setIdCategorie(id);
  //   const element = items.find((item) => item.id === id);
  //   setValueOfCategorie(element.libelle);
  //   console.log("ELEMENT", element);
  //   setVisibleModifier(true);
  // };
  // const handleModification = async () => {
  //   setIsLoadingChange(true);
  //   try {
  //     const response = await instance.put(
  //       "categories/" + idCategorie,
  //       dataModif
  //     );
  //     console.log("CATEGORIE_MODIFIER", response);
  //     const element = items.find((item) => item.id === idCategorie);
  //     element.libelle = dataModif.libelle;
  //     setIsLoadingChange(false);
  //   } catch (error) {
  //     console.log(error);
  //     setIsLoadingChange(false);
  //   }
  // };
  // const handleDeleteCategorie = async()=>{
  //   setIsLoadingChange(true);
  //   try {
  //     const response = await instance.delete(
  //       "categories/" + idCategorie
  //     );
  //     console.log("CATEGORIE_DELETE", response);
  //     if(response.data.status === true){
  //       const element = items.findIndex((item) => item.id === idCategorie);
  //       items.splice(element, 1);
  //       setIsLoadingChange(false);
  //       setVisible(false);
  //       MySwal.fire({
  //         title: `La catégorie a été supprimée avec succès `,
  //         icon: "success",
  //         showConfirmButton: true,
  //       });
       
  //     }
  //     if(response.data.status === false){
  //       MySwal.fire({
  //         title: response.data.message.libelle[0],
  //         icon: "info",
  //         showConfirmButton: true,
  //       });
  //     }
      
  //   } catch (error) {
  //     console.log(error);
  //     setIsLoadingChange(false);
  //   }
  // }
  const detailsInfo = (rowData) => {
    return <MenuPoint optionMenu={options} idData={rowData.id} />;
  };
  // const detailsInfo = (rowData) => {
  //   return (
  //     <div className="d-flex align-items-center gap-5 justify-content-center">

  //       <button
  //         className="btn-lg bg-danger border-0 rounded-3 p-2 text-light fw-bold"
  //         onClick={() => handleCatgeorie(rowData.id)}
  //       >
  //         <MdDeleteOutline fontSize="1.5em" />
  //         Supprimer
  //       </button>
  //     </div>
  //   );
  // };

  
  // const renderHeader = () => {
  //   const conteneurSearch = {
  //     padding: "1.3em",
  //   };
  //   return (
  //     <div className="conteneur-search">
  //       <Dialog
  //         header="Voulez-vous vraiment supprimer cette catégorie"
  //         visible={visible}
  //         style={{ width: "50vw" }}
  //         onHide={() => {
  //           if (!visible) return;
  //           setVisible(false);
  //         }}
  //       >
  //         <button 
  //         onClick={()=>handleDeleteCategorie()}
  //         className="btn-lg bg-warning mx-2 border-0 rounded-3 p-2 text-light fw-bold">
  //          {isLoadingChange ? "Chargement..." : "Confirmer"}
  //         </button>
  //         <button
  //           onClick={() => setVisible(false)}
  //           className="btn-lg bg-danger mx-2 border-0 rounded-3 p-2 text-light fw-bold"
  //         >
  //           Annuler
  //         </button>
  //       </Dialog>
  //       <Dialog
  //         header="Modification de la catégorie"
  //         visible={visibleModifier}
  //         style={{ width: "50vw" }}
  //         onHide={() => {
  //           if (!visibleModifier) return;
  //           setVisibleModifier(false);
  //         }}
  //       >
  //         <input
  //           type="text"
  //           defaultValue={valueOfCategorie}
  //           onChange={(e) =>
  //             setDataModif({ ...dataModif, libelle: e.target.value })
  //           }
  //         />
  //         <button
  //           onClick={() => handleModification()}
  //           className="btn-lg bg-warning mx-2 border-0 rounded-3 p-2 text-light fw-bold"
  //         >
  //           {isLoadingChange ? "Chargement..." : "Confirmer"}
  //         </button>
  //         <button
  //           onClick={() => setVisibleModifier(false)}
  //           className="btn-lg bg-danger mx-2 border-0 rounded-3 p-2 text-light fw-bold"
  //         >
  //           Annuler
  //         </button>
  //       </Dialog>
  //       {/* <div className="btn-upload-file">
  //           <Button
  //             type="button"
  //             label="Excel format"
  //             icon="pi pi-file-excel"
  //             style={{
  //               border: "none",
  //               color: "white",
  //               margin: "1em 0",
  //             }}
  //             onClick={exportExcel}
  //             data-pr-tooltip="XLS"
  //           />
  //         </div> */}

  //       <InputText
  //         value={globalFilterValue}
  //         onChange={onGlobalFilterChange}
  //         placeholder="Keyword Search"
  //         style={conteneurSearch}
  //       />
  //     </div>
  //   );
  // };
  // const header = renderHeader();

  return (
    <div>
      <ModalDelete
        modalTitle={"Voulez-vous vraiment supprimer cette catégorie ?"}
        setOpenMethod={setOpen}
        openProp={open}
        dataInfoForBtn={
        [{
          libelleBtn:"Oui",
          color:"error",
          methode:()=>{
            console.log("dff")
            // if(isRejectedBtn){
            //   changeStatut('refuse',valueTextField)
            // }
            // if(!isRejectedBtn){
            //   changeStatut('accepter')
            // }
          }
        },{
          libelleBtn:"Non",
          isStyle:true,
          methode:()=>{
             console.log("dff")
            // dispatch(showModal())
          }
        }]
      }
      />
      <TabView>
        <TabPanel>
          <DataTable
            ref={dt}
            value={items}
            tableStyle={{ minWidth: "50rem" }}
            paginator
            rows={10}
            filters={filters}
            globalFilterFields={["libelle"]}
          >
            <Column
              field="label"
              style={{ textAlign: "center" }}
              header="libellé"
            ></Column>
            <Column
              field="id"
              style={{ textAlign: "center" }}
              header="Action"
              body={detailsInfo}
            ></Column>
          </DataTable>
        </TabPanel>
      </TabView>
    </div>
  );
}

export default ListeCategorie;
